<template>
  <div>
    <v-container>
      <v-row>
        <v-btn class="mb-2" fab to="/MaterialG">
          <v-icon dark>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="buscar" label="Buscar" outlined clearable hide-details></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-for="article in articles" :key="article.id">
          <v-card @click="afegir(article)">
            <v-card-text>
              <v-row>
                <b>
                  {{ article.id }}
                </b>
              </v-row>
              <v-row>
                {{ article.descripcio }}
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-btn class="mt-6" fab to="/MaterialG">
          <v-icon dark>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import api from "../api.js";

export default {
  data: () => ({
    buscar: "",
    articles: [],
  }),
  methods: {
    load() {
      api.post("/api/v1/articlesG", {
        emp: api.getEmp(),
        buscar: this.buscar,
      }).then((response) => {
        this.articles = response.data;
      });
    },
    afegir(article) {
      var material = localStorage.getItem("systimes.material" + api.getEmp());
      var m = [];
      if (material != null && material != "") {
        m = JSON.parse(material);
      }

      // Afegir article triat
      m.push({
        id: article.id,
        descripcio: article.descripcio,
        triat: true,
        quantitat: "1",
      });

      // Guardar articles
      localStorage.setItem("systimes.material" + api.getEmp(), JSON.stringify(m));

      this.$router.push("/MaterialG");
    },
  },
  mounted() {
    //this.load();
  },
  watch: {
    buscar() {
      this.load();
    },
  },
};
</script>